const INFO = {
	main: {
		title: "Emmanuel Kyeremeh",
		name: "Emmanuel Kwadwo Aning Kyeremeh",
		email: "josephkyeremeh53@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://x.com/aning49",
		github: "https://github.com/emmanuelkyeremeh",
		linkedin: "https://www.linkedin.com/in/emmanuelkyeremeh",
		instagram: "https://www.instagram.com/aning_49/",
		stackoverflow: "https://stackoverflow.com/users/15140529/emmanuel-aning",
		facebook: "https://facebook.com/emmanuel.aning.56/",
	},

	homepage: {
		title: "Hi, I am a Software Engineer and Data Analyst",
		description:
			"I am a Software Engineer with expertise in React.js, Next.js, Node.js, Express.js FastApi, Flask and MongoDB. I am also a Data Analyst with experience with analyzing data and building machine learning models using Python.",
	},

	about: {
		title: "I’m Emmanuel Kyeremeh. I live in Accra, Ghana, where I design and build software.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},


	projects: [
		{
			title: "Echomeet",
			description:
				"EchoMeet enables users to extract text from meeting recordings using Whisper.cpp and generate concise meeting summaries with LLaMA 3.1. All processing is performed 100% locally, and users can also record meetings live and receive real-time summaries.",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1764194110/uvnauhjf9uawbtpg3mgy.png",
			linkText: "View Project",
			link: "https://github.com/emmanuelkyeremeh/echomeet",
		},
		{
			title: "Cognidoc",
			description:
				"Congidoc enables users to upload documents directly in their browser and chat with an AI model that analyzes the content. The entire application runs offline using WebLLM and is built with React.js and Vite.",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1764193637/tr9cespxjdg2cudez7em.png",
			linkText: "View Project",
			link: "https://cognidocai.vercel.app",
		},
		{
			title: "Chordara",
			description:
				"Chordara allows users to generate music by describing the type of music they want to generate in a prompt. Built with React and Firebase with models sourced from openrouter and music generation from javascript code using dittyboy",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1758877893/weer7soushei1y3wsmfl.png",
			linkText: "View Project",
			link: "https://chordara.vercel.app",
		},
		{
			title: "Mindflow",
			description:
				"This web app allows users to generate 3D mind maps powered by AI where the model learns from existing nodes and can help users expand their mind maps. This app was built using React.js and Firebase",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1758877155/yl8x4h5ti9jiej56jrkp.png",
			linkText: "View Project",
			link: "https://mindflow-dev-ai.vercel.app",
		},
		{
			title: "Profina",
			description:
				"Create resumes from up to 3 templates with the help of AI. Users get to fill their data where the can leverage AI to polish sections of their data which is then autofilled into nicely designed ATS friendly templates which can be downloaded. This app was built using React.js and Firebase",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1758876519/liwjwtbhazfpgn0kjbua.png",
			linkText: "View Project",
			link: "https://profina-ai.vercel.app",
		},
		{
			title: "ProposeAI",
			description:
				"This web app allows users, particularly freelancers and solopreneurs to generate proposals, powered by AI, built with React.js and Firebase",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1758875916/lhqcfqrrrx3yehrkyhmv.png",
			linkText: "View Project",
			link: "https://propose-ai.vercel.app",
		},
		{
			title: "Velocify",
			description:
				"Web App For Data Visualization. Velocify allows users to create up to 15 2D and 3D charts of their csv data",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1758875536/frriuwjbaneutkx6durp.png",
			linkText: "View Project",
			link: "https://velocify.vercel.app",
		},
		{
			title: "Audiophile",
			description:
				"fully functional E-commerce website built using React.js",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1750532394/sxeryyeh9nj6rxd18duy.png",
			linkText: "View Project",
			link: "https://audiophile-two-tan.vercel.app/",
		},
				{
			title: "SurvAI",
			description:
				"AI Powered survey application. This app allows users to create, edit,delete and share surveys and also create surveys completely using AI",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1751750387/kkgyxzxgptmwn6fmiqng.png",
			linkText: "View Project",
			link: "https://survai-bz5qtpcec-emmanuelkyeremehs-projects.vercel.app/",
		},
		{
			title: "Invoice Application",
			description:
				"Invoice Application built using React.js",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1750533092/wxbsbzsyrddoke7p3qht.png",
			linkText: "View Project",
			link: "https://invoice-app-two-liart.vercel.app/",
		},
		{
			title: "Portable Bluetooth Speaker",
			description:
				"Portable bluetooth speaker application using MATLAB and Arduino",
			logo: "https://camo.githubusercontent.com/9f565b87e84052396c60c06537db8a53f73a6896845fdaa984fe7541989a1a3a/68747470733a2f2f7265732e636c6f7564696e6172792e636f6d2f656d6d616e75656c6b65706c65722f696d6167652f75706c6f61642f76313637393236323939392f70696374757265395f63796f6d68682e6a7067",
			linkText: "View Project",
			link: "https://github.com/emmanuelkyeremeh/portable-bluetooth-speaker",
		},

		{
			title: "Crop Disease Detection",
			description:
				"Mobile Application developed using React Native and Expo for detecting diseases affecting tomato and pepper crops using an integrated machine learning model",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1750531779/u3fkovus1lopaaqjoyji.jpg",
			linkText: "View Project",
			link: "https://github.com/emmanuelkyeremeh/crop-disease-detection",
		},

		{
			title: "IFC Building Components Dashboard",
			description:
				"Visualization of the keywords of the various component of building designs in Industry Foundation Classes (IFC) files built using dash plotly.",
			logo: "https://res.cloudinary.com/emmanuelkepler/image/upload/v1750532765/xewgco80syw2pvqi8xtp.png",
			linkText: "View Project",
			link: "https://results-visualization.onrender.com/",
		},
	],
};

export default INFO;
